import * as React from 'react';
import { useTranslation } from 'react-i18next';

import './scss/style.scss';

const YandexReviewsWidget = function() {
  const { t } = useTranslation();

  return (
    <div className={'yandex_reviews_widget'}>
      <iframe
        src={'https://yandex.ru/maps-reviews-widget/1737394341?comments'}
        title={'Yandex Maps Reviews'}
      />
      <a
        className={'yandex_reviews_link'}
        href={'https://yandex.by/maps/org/stalnaya_liniya/1737394341/'}
        rel={'noopener noreferrer'}
        target={'_blank'}
      >
        {t('yandex_maps_review_link')}
      </a>
    </div>
  );
};

export default YandexReviewsWidget;
